import { useContext } from 'react';
import TileButton from './components/TileButton.jsx';
import { InteractionContext } from '../../contexts';

const ActionItem = () => {
  const { values, handleChange } = useContext(InteractionContext);

  return (
    <TileButton
      buttonText={values.answers[0]}
      buttonIndex={0}
      onChangeButtonText={handleChange}
    />
  );
};

export default ActionItem;
